import React from "react";
import * as S from "./style";
import moment from "moment";
import { FiChevronRight } from "react-icons/fi";

interface Props {
  data?: any;
  tab: string;
  goToDetail?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

function CardNewLetter({
  data,
  tab,
  goToDetail,
  onMouseEnter,
  onMouseLeave,
}: Props) {
  return (
    <S.Container
      onClick={goToDetail}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="title">
        {tab === "artInside" ? (
          <>
            <div className="date">
              {!data?.createdAt ? "" : moment(data?.createdAt).format("YYYY")}
            </div>
            <div className="vol">
              {!data?.createdAt ? "" : moment(data?.createdAt).format("MM.DD")}
            </div>
          </>
        ) : (
          <>
            <div className="date">
              {!data?.createdAt
                ? ""
                : moment(data?.createdAt).format("YYYY.MM")}
            </div>
            <div className="vol">Vol {data?.newsletterVol}</div>
          </>
        )}
      </div>
      <div className="line"></div>
      <div className="newsletter">
        {tab === "artInside" ? (
          <div className="artInside">{data?.title}</div>
        ) : (
          <div className="titles">
            <div className="main">{data?.newsletterTitle1}</div>
            <div className="sub">{data?.newsletterTitle2}</div>
          </div>
        )}

        <div className="more-btn">
          <FiChevronRight size={24} color="#ffffff" />
        </div>
      </div>
    </S.Container>
  );
}

export default CardNewLetter;
